import React from 'react';
import moment from 'moment';
import { formatPartialOfferTime } from '../../utils/timeFormatting';

interface TimeDebuggerProps {
  timeData: {
    offeredStartTime?: string;
    offeredEndTime?: string; 
    offeredStartTimeLocal?: string;
    offeredEndTimeLocal?: string;
    postedStartTime?: string;
    postedEndTime?: string;
  };
  location?: {
    lat?: number;
    lon?: number;
  };
  isVisible?: boolean;
}

const TimeDebugger: React.FC<TimeDebuggerProps> = ({ 
  timeData, 
  location, 
  isVisible = false // Temporarily disabled to test cancellation issue fix
  // isVisible = (process.env.NODE_ENV as string) === 'staging' || (process.env.NODE_ENV as string) === 'local'
}) => {
  if (!isVisible) return null;

  // Safe time formatting with error handling
  const safeFormatTime = (timeStr?: string, localTimeStr?: string, lat?: number, lon?: number): string => {
    try {
      return formatPartialOfferTime(timeStr, localTimeStr, lat, lon) || 'N/A';
    } catch (error) {
      console.warn('TimeDebugger formatting error:', error);
      return 'Error formatting';
    }
  };

  // Safely build debug info with error handling
  let debugInfo: any = {};
  
  try {
    debugInfo = {
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      platform: navigator.platform,
      userAgent: navigator.userAgent.substring(0, 100) + '...', // Truncate to prevent overflow
      utcOffset: new Date().getTimezoneOffset(),
      localTime: new Date().toLocaleString(),
      momentVersion: moment.version,
      
      // Safely handle time data
      timeDataExists: !!timeData,
      locationExists: !!location,
      
      // Time conversions with safe handling
      offeredStartUTC: timeData?.offeredStartTime || 'N/A',
      offeredStartLocal: timeData?.offeredStartTimeLocal || 'N/A',
      offeredStartFormatted: safeFormatTime(
        timeData?.offeredStartTime, 
        timeData?.offeredStartTimeLocal, 
        location?.lat, 
        location?.lon
      ),
      
      offeredEndUTC: timeData?.offeredEndTime || 'N/A',
      offeredEndLocal: timeData?.offeredEndTimeLocal || 'N/A',
      offeredEndFormatted: safeFormatTime(
        timeData?.offeredEndTime, 
        timeData?.offeredEndTimeLocal, 
        location?.lat, 
        location?.lon
      ),
      
      postedStartFormatted: safeFormatTime(
        timeData?.postedStartTime, 
        undefined, 
        location?.lat, 
        location?.lon
      ),
      
      postedEndFormatted: safeFormatTime(
        timeData?.postedEndTime, 
        undefined, 
        location?.lat, 
        location?.lon
      ),
    };
  } catch (error) {
    console.error('TimeDebugger error building debug info:', error);
    debugInfo = { 
      error: 'Failed to build debug info', 
      errorMessage: error instanceof Error ? error.message : String(error) 
    };
  }

  return (
    <div style={{ 
      position: 'fixed', 
      bottom: 0, 
      left: 0, 
      right: 0, 
      backgroundColor: 'rgba(0,0,0,0.8)', 
      color: 'white', 
      padding: '10px', 
      fontSize: '10px',
      zIndex: 9999,
      maxHeight: '200px',
      overflowY: 'auto'
    }}>
      <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>Time Debug Info:</div>
      <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
        {(() => {
          try {
            return JSON.stringify(debugInfo, null, 2);
          } catch (jsonError) {
            return 'Error serializing debug info: ' + String(jsonError);
          }
        })()}
      </pre>
    </div>
  );
};

export default TimeDebugger; 